// extracted by mini-css-extract-plugin
module.exports = {"profileCardGrid":"ProfileProductGrid_profileCardGrid__qQSN5"};